import React, { useContext } from "react";
import { Modal, Form, Input, Select } from "antd";
import { useMutation, useQuery, useQueryClient } from "react-query";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { toast } from "react-toastify";
import PowerBiContext from "../../context/PowerBiContext";

const AddPowerBi = ({ isOpen, isAddMode }) => {
  const powerBiContext = useContext(PowerBiContext);
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const {
    data: clientData = [],
  } = useQuery(
    ["get-clients"],
    async () => {
      const res = await axiosInstance.get("api/clients/getAllClients?status=active");
      return res.data?.data || [];
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const createPowerBiLink = useMutation(
    (formData) => axiosInstance.post("api/powerbi-module/addPowerbiLink", formData),
    {
      onSuccess: (res) => {
        toast.success(res.data?.message || "Power BI Link added successfully");
        queryClient.invalidateQueries("powerbi-links");
        handleClose();
      },
      onError: (err) => {
        toast.error(err.response?.data?.message || "Failed to add link");
      },
    }
  );

  const handleClose = () => {
    powerBiContext.updateOpenModal(false);
    powerBiContext.updateAddMode(true);
    form.resetFields();
  };

  const handleSubmit = (values) => {
    createPowerBiLink.mutate(values);
  };

  return (
    isOpen && (
      <div className="client-modal-info">
        <Modal
          className="add-user-modal"
          open={isOpen}
          onCancel={handleClose}
          width={800}
          maskClosable={false}
          footer={null}
        >
          <div className="client-modal">
            <div className="modal-title-powerbi">
              <h3>{isAddMode ? "Add Power BI Link" : "Edit Power BI Link"}</h3>
            </div>

            <Form
              layout="vertical"
              form={form}
              onFinish={handleSubmit}
              className="modal-body-container"
            >
              <div className="modal-wrapper-body">
                <div className="modal-wrapper-content">
                  <h4>Link Details</h4>

                  <div className="add-modal-row">
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true, message: "Title is required" }]}
                    >
                      <Input placeholder="Enter Title" />
                    </Form.Item>

                    <Form.Item
                      name="link"
                      label="Link"
                      rules={[{ required: true, message: "Link is required" }]}
                    >
                      <Input placeholder="Enter Power BI URL" />
                    </Form.Item>
                  </div>

                  <h4>Client Information</h4>

                  <div className="add-modal-row">
                    <Form.Item
                      name="clientIds"
                      label="Clients"
                      rules={[{ required: true, message: "Please select clients" }]}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select one or more clients"
                        size="large"
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        style={{ width: "100%" }}
                        options={clientData.map((client) => ({
                          label: `${client.adminFirstName} ${client.adminLastName}`,
                          value: client._id,
                        }))}
                      />
                    </Form.Item>
                  </div>

                  <div className="add-modal-row">
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ max: 500, message: "Max 500 characters allowed" }]}
                    >
                      <Input.TextArea
                        placeholder="Enter description (optional)"
                        rows={3}
                        style={{ resize: "none" }}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="flex justify-end client-modal-footer">
                <button type="submit" className="ant-btn primary-btn mr-3">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    )
  );
};

export default AddPowerBi;
